export function parseDateValue(value) {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

function parseDateOnlyValue(value) {
  if (!value) return null;

  const text = String(value);
  const isoDate = text.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (isoDate) {
    return new Date(
      Number(isoDate[1]),
      Number(isoDate[2]) - 1,
      Number(isoDate[3])
    );
  }

  const date = parseDateValue(value);
  if (!date) return null;

  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

export function formatDateForDisplay(value) {
  if (!value) return "";

  const text = String(value);
  const isoDate = text.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (isoDate) return `${isoDate[3]}/${isoDate[2]}/${isoDate[1]}`;

  const date = parseDateValue(value);
  return date ? date.toLocaleDateString("en-GB") : "";
}

export function mapExportUnitExclusionRows(apiRows) {
  return (Array.isArray(apiRows) ? apiRows : []).map((row, index) => {
    const unit = row.Unit ?? row.unit ?? "";
    const operator = row.Operator ?? row.operator ?? row.OperatorDescription ?? row.operatorDescription ?? "";
    const startDate = row.StartDate ?? row.start_date ?? row.startDate ?? null;
    const endDate = row.EndDate ?? row.end_date ?? row.endDate ?? null;

    return {
      id: `${unit}-${startDate || "no-start"}-${index}`,
      unit,
      operator,
      startDate,
      endDate,
    };
  });
}

export function uniqueExportUnitExclusionUnits(rows = []) {
  return [...new Set((rows || []).map((row) => row.unit).filter((unit) => unit !== "" && unit != null))]
    .sort((a, b) => {
      const an = Number(a);
      const bn = Number(b);
      if (!Number.isNaN(an) && !Number.isNaN(bn)) return an - bn;
      return String(a).localeCompare(String(b));
    });
}

export function uniqueExportUnitExclusionOperators(rows = []) {
  return [...new Set((rows || []).map((row) => row.operator).filter(Boolean))]
    .sort((a, b) => String(a).localeCompare(String(b)));
}

function isActiveOnDate(row, dateFilter = "") {
  const filterDate = parseDateOnlyValue(dateFilter);

  if (!filterDate) return true;

  const exclusionStart = parseDateOnlyValue(row.startDate);
  const exclusionEnd = parseDateOnlyValue(row.endDate);

  if (!exclusionStart) return false;
  if (filterDate < exclusionStart) return false;
  if (exclusionEnd && exclusionEnd < filterDate) return false;

  return true;
}

export function filterExportUnitExclusions(
  data,
  searchQuery = "",
  filters = { unit: [], operator: [] },
  dateFilter = ""
) {
  const q = searchQuery?.toLowerCase?.() ?? "";
  const selectedUnits = filters.unit || [];
  const selectedOperators = filters.operator || [];

  return (data || []).filter((row) => {
    if (
      selectedUnits.length &&
      !selectedUnits.map((unit) => String(unit)).includes(String(row.unit))
    ) {
      return false;
    }

    if (
      selectedOperators.length &&
      !selectedOperators.includes(row.operator)
    ) {
      return false;
    }

    if (!isActiveOnDate(row, dateFilter)) return false;

    if (!q) return true;

    const haystack = [
      row.unit,
      row.operator,
      row.startDate,
      row.endDate,
      formatDateForDisplay(row.startDate),
      formatDateForDisplay(row.endDate),
    ]
      .map((value) => String(value ?? "").toLowerCase())
      .join(" ");

    return haystack.includes(q);
  });
}

export function generateExportUnitExclusionFileName() {
  const ts = new Date().toISOString().replace(/[-:]/g, "").replace(/\..+/, "").replace("T", "_");
  return `export_unit_exclusions_${ts}.csv`;
}
